export default {
    state: {
        buildings: null,
        apartments: null,
        building_id: 1,
        floor: null,
        apartment_id: null,
        email: null,
        tel: null,
    },

    getters: {
        building(state) {
            return state.buildings.find((item) => item.id === state.building_id);
        },
        apartments(state) {
            return state.apartments.filter(
                (item) => item.building_id === state.building_id,
            );
        },
        floorApartments(state) {
            return state.apartments.filter(
                (item) =>
                    item.building_id === state.building_id && item.floor === state.floor,
            );
        },
        apartment(state) {
            return state.apartments.find((item) => item.id === state.apartment_id);
        },
    },

    mutations: {
    },

    actions: {
    },
};
